import React from 'react';

import { bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'Step';

interface Props {
	className?: string;
	h?: boolean;
	larger?: boolean;
	lg?: boolean;
	md?: boolean;
	sm?: boolean;
	smaller?: boolean;
	v?: boolean;
	xl?: boolean;
	xs?: boolean;
	xxl?: boolean;
	xxs?: boolean;
	xxxs?: boolean;
}

function Step(props: Props): JSX.Element {
	const { h, larger, lg, md, sm, smaller, v, xl, xs, xxl, xxs, xxxs } = props;

	return (
		<div
			className={bm(
				MODULE_NAME,
				{
					h,
					larger,
					lg,
					md,
					sm,
					smaller,
					v,
					xl,
					xs,
					xxl,
					xxs,
					xxxs,
				},
				props.className
			)}
		/>
	);
}

export default Step;
